<template>
  <v-card flat>
    <v-list-item two-line class="pt-0">
      <v-list-item-content>
        <v-list-item-title class="headline">Mes instances</v-list-item-title>
        <v-list-item-subtitle
          >Liste des instances dans lesquelles je suis</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
      <v-tabs @change="changeTab" v-model="tab" color="primary">
        <v-tab>
          Participant
        </v-tab>

        <v-tab>
          Gestionnaire
        </v-tab>

        <v-tab-item>
          <datasource-table :datasource="datasourceInstanceParticipant">
            <template #item.nom="{item}">
              <navigable-link :to="$liens().instance(item.id)">
                {{ item.nom }}
              </navigable-link>
            </template>
          </datasource-table>
        </v-tab-item>

        <v-tab-item>
          <datasource-table :datasource="datasourceInstanceGestionnaire">
            <template #item.nom="{item}">
              <navigable-link :to="$liens().instance(item.id)">
                {{ item.nom }}
              </navigable-link>
            </template>
          </datasource-table>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
export default {
  mounted() {
    this.datasourceInstanceParticipant.refresh();
  },
  data() {
    const store = this.$store.state.rechercheavancee;
    const datasourceInstanceParticipant = new Datasource(
      'recherche/avancee/instance/mes/participants',
      {
        body: {},
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nom'],
        descending: [false],
        labelNamespace: 'recherche.rechercheSimple.instance.list',
        fields: [
          {
            value: 'nom',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.nom',
            ),
          },
          {
            value: 'referent',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.referent',
            ),
          },
          {
            value: 'nomsGestionnaires',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.personnePhysique',
            ),
          },
          {
            value: 'size',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.numberOfUser',
            ),
          },
        ],
      },
    );

    const datasourceInstanceGestionnaire = new Datasource(
      'recherche/avancee/instance/mes/gestionnaire',
      {
        body: {},
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nom'],
        descending: [false],
        labelNamespace: 'recherche.rechercheSimple.instance.list',
        fields: [
          {
            value: 'nom',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.nom',
            ),
          },
          {
            value: 'referent',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.referent',
            ),
          },
          {
            value: 'nomsGestionnaires',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.personnePhysique',
            ),
          },
          {
            value: 'size',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.numberOfUser',
            ),
          },
        ],
      },
    );

    return {
      datasourceInstanceParticipant,
      datasourceInstanceGestionnaire,
      tab: store.tab ? store.tab : 0,
      typeObjet: 'participants',
    };
  },
  computed: {
    datasource() {
      if (this.tab === 0) {
        return this.datasourceInstanceParticipant;
      } else if (this.tab === 1) {
        return this.datasourceInstanceGestionnaire;
      }
      return null;
    },
  },
  methods: {
    changeTab() {
      this.datasource.debouncedRefresh();
    },
  },
};
</script>
